import Joi from 'joi';
import Form from '../common/form';
import Progress from '../themed/progress';
import PropTypes from 'prop-types';

import { ProgressComment } from '../../utils/models';
import { getErrorMessage } from '../../utils/utilities';

import { addProgressComment } from '../../services/projectService';
import { promise } from '../../services/toastService';
import { getCurrentUser } from '../../services/authService';

import withRouter from '../hoc/withRouter';
import withProjectDetails from '../hoc/withProjectDetails';

type StateData = Pick<ProgressComment, 'body' | 'title' | 'pageNumber'>;
class ProgressCommentForm extends Form {
	state = {
		data: {
			title: '',
			body: '',
			pageNumber: 1
		},
		errors: {},
		progress: 0,
		loading: false,
	};

	schema = {
		title: Joi.string().min(3).required().label('Comment Title'),
		body: Joi.string().min(10).required().label('Comment Body'),
		pageNumber: Joi.number().positive().required().label('Page Number'),
	};

	static propTypes = {
		currentPage: PropTypes.number
	}

	componentDidMount() {
		const user = getCurrentUser();
		if (user) {
			this.setState({ data: { ...this.state.data, title: `Comment by ${user.firstName} ${user.lastName}` }});
		}
	}

	componentDidUpdate(previousProps: { currentPage: number }, previousState: { data: StateData }) {
		if (previousProps.currentPage !== this.props.currentPage) {
			this.setState({ data: { ...this.state.data, pageNumber: this.props.currentPage }});
		}
	}

	handleAddComment = async () => {
		const { params } = this.props;
		const { data } = this.state;

		await addProgressComment(params.projectId, data, this.handleProgressChange);
		await this.props.fetchProjectDetails();

		this.setState({
			data: {
				title: '',
				body: '',
				pageNumber: this.props.currentPage,
			}
		});
	};

	doSubmit = async () => {
		promise(this.handleAddComment(), {
			loading: 'Adding Comment',
			success: () => 'Comment Added Successfully',
			error: getErrorMessage,
		});
	};

	render() {
		return (
			<div className="p-4 bg-white border">
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					{this.renderTextArea({
						label: 'Comment',
						placeholder: 'Enter Comment',
						name: 'body',
						rows: '6',
					})}

					<div className="d-flex justify-content-end">
						{this.renderButton('Submit Comment')}
					</div>
				</form>
			</div>
		);
	}
}

const WithRouterProgressCommentForm = withRouter(ProgressCommentForm);
export default withProjectDetails(WithRouterProgressCommentForm);
